export default function () {
  const widgetName = 'hcHeroBanner';
  const widgetOpts = hcHeroBannerOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function () {

      $(`#${widgetName} .card-widget-item`).each(function () {

        let heroBannerUrl = $(this).find('.image-container').attr('style');
        let heroBannerAltText = $(this).find('.image-container').text();

        $('.subpageContainer').find('.heroBannerContainer').attr('style', heroBannerUrl);
        $('.subpageContainer').find('.heroBannerContainer').attr('alt', heroBannerAltText);

        $('.subpageContainer').find('.heroMainImage').attr('style', heroBannerUrl);
        $('.subpageContainer').find('.heroMainImage').attr('alt', heroBannerAltText);
        
        $('.subpageContainer').find('.pageTitle').attr('alt',heroBannerAltText);

        setTimeout(() => {
          $('.subpageContainer').find('.heroBannerContainer').css('opacity', '1');
          $('.subThemeHomePage').find('.subPageCards').css('opacity', '1');
          $('.subpageContainer').find('.pageTitle').css('opacity', '1');
        }, 500);
      })

      $(`#${widgetName}`).remove();
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: [''],
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });

}